import http from "./main";

export default {
  /**
   * @param {string} query
   * @param {number} page
   * @param {number} num
   * @returns {Promise}
   * @description
   * This function is used to search for patients
   */
  search: async (query, page, num) => {
    return await http.get(
      `/patients/search?search=${query}&page=${page}&num=${num}`
    );
  },
  searchCount: async (query) => {
    return await http.get(`patients/searchCount?search=${query}`);
  },
  getAll: async (page, limit) => {
    return await http.get(`/all-patients?page=${page}&limit=${limit}`);
  },
};
